import { jsx as _jsx } from "react/jsx-runtime";
import { AuthProvider as BaseAuthProvider } from "./auth-context.js";
import { OrganizationProvider } from "./organization-context.js";
export function PlatformAuthProvider({ children, config }) {
    return (_jsx(BaseAuthProvider, { config: config, children: _jsx(OrganizationProvider, { config: config, children: children }) }));
}
export { AuthProvider as BaseAuthProvider } from "./auth-context.js";
export { OrganizationProvider } from "./organization-context.js";
//# sourceMappingURL=auth-provider.js.map